import { Ticket, TicketCategory } from "@signalist/shared-types";

import { matchesTab, SupportTicketTab } from "./ticketTabs";

export interface TicketFilterOptions {
	tab: SupportTicketTab;
	search: string;
	category: TicketCategory | null;
	/** The current user's id when a company admin narrows the list to their own tickets. */
	onlyMineUserId: number | null;
}

const filerName = (ticket: Ticket): string =>
	[ticket.createdBy?.firstName, ticket.createdBy?.lastName].filter(Boolean).join(" ");

/** Subject, ticket number (with or without `#`), and the filer's name / e-mail. */
export const matchesTicketSearch = (ticket: Ticket, search: string): boolean => {
	const needle = search.trim().toLowerCase();

	if (!needle) {
		return true;
	}

	const haystack = [
		ticket.subject,
		String(ticket.id),
		filerName(ticket),
		ticket.createdBy?.email ?? "",
	]
		.join(" ")
		.toLowerCase();

	return haystack.includes(needle.startsWith("#") ? needle.slice(1) : needle);
};

export const filterTickets = (tickets: Ticket[], options: TicketFilterOptions): Ticket[] =>
	tickets.filter(
		(ticket) =>
			matchesTab(ticket, options.tab) &&
			matchesTicketSearch(ticket, options.search) &&
			(options.category === null || ticket.category === options.category) &&
			(options.onlyMineUserId === null || ticket.createdByUserId === options.onlyMineUserId)
	);
